import React, { Component } from "react";
import { connect } from "react-redux";
import * as postActions from "../../store/action/post";
import * as configActions from "../../store/action/config";
import moment from "moment";
import Link from "src/components/link";
import Select from "react-select";
import * as _ from "lodash";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";

import Input from "../../components/input/Input";
import ApiService from "../../services/ApiService";
import { ToastContainer, toast } from 'react-toastify';
import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import slug from '@sindresorhus/slugify'
import { filtersToQueryString } from "../../utils/post-filter";
import './export_royalties.scss';
// import * as jsPDF from 'jspdf'

import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
class Export extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      valueExport: null,
      shouldDowloadFile: false,
      preparingData: false,
      listPost: [],
      exportTypes: [
        { value: "pdf", label: "PDF", code: "" },
        { value: "excel", label: "Excel", code: "" }
      ],
      dataExcel: [],
      filters: {}
    }
  }

  downloadData = () => {
    let filters = JSON.parse(JSON.stringify(this.props.filters));
    filters.limit.value = -1;
    let queryString = filtersToQueryString(filters, true);
    this.setState({preparingData: true}, () => {
      ApiService.get(`/posts/rolyalties?pr_type=0${queryString}`).then(result => {
        // console.log(result);
        let postList = result.posts;
        let lstTmp = [];
        postList.forEach((post, idx) => {
          const money_editor = post.royalties_editor_value
            ? parseInt(post.royalties_editor_value.value * 1000)
            : 0;
          const money_photo = post.royalties_photo_value
            ? parseInt(post.royalties_photo_value.value * 1000)
            : 0;
          let title = post.title || "";
          let publish = moment(post.publishedAt).format("DD/MM hh:mm");
          let category = this.generateCategory(idx, post.categories)[0];
          let editor = post.royalties_editor ? post.royalties_editor.label : '';
          let photo = post.royalties_photographer ? post.royalties_photographer.label : '';
          let view = post.pageviews ? post.pageviews : '';
          let pageviews_value = (post.pageviews_value && post.pageviews && post.pageviews_value < post.pageviews) ? post.pageviews_value : '';
          let ai_score = post.ai_score ? post.ai_score : 0;
          let timeOnPage = post.timeOnPage ? post.timeOnPage : 0;
          let video = post.video_url ? 'Có' : 'Không';
          let moneye = money_editor
          let moneyp = money_photo
          let money_total = money_editor + money_photo
          let contentpenname = post.contentpenname ? post.contentpenname.map(item => item.label).join(", ") : [];
          let item = [title, publish, category, editor, contentpenname, timeOnPage, view, pageviews_value, video, ai_score];
          lstTmp.push(item);
        });
        this.setState({
          listPost: result.posts, showModal: true, dataExcel: lstTmp, shouldDowloadFile: true, preparingData: false
          // filters
        })
      });
      })
    }

  generateCategory = (idx, category) => {
    category = _.unionBy(category, "_id");
    let stringBuilder = [];
    category.forEach((cat, index) => {
      if (index === 0) {
        let stringBuilder1 = cat.name;
        stringBuilder.push(stringBuilder1);
      }
    });
    return stringBuilder;
  }

  componentDidMount() {
    this.setState({
      filters: JSON.parse(JSON.stringify(this.props.filters)),
    });
  }

  formatNumber(number) {
    var tier = (Math.log10(number) / 3) | 0;
    if (tier == 0) return number;
    var suffix = SI_SYMBOL[tier];
    var scale = Math.pow(10, tier * 3);
    var scaled = number / scale;

    return parseFloat(scaled.toFixed(1)) + suffix;
  }

  componentDidUpdate(prevProps) {
    if(this.state.shouldDowloadFile && !this.state.preparingData){
      this.setState({shouldDowloadFile: false})
    }
    if (JSON.stringify(this.props.filters) !== JSON.stringify(this.state.filters)) {
      this.setState({filters: JSON.parse(JSON.stringify(this.props.filters))})
    }
  }

  render() {
    const { filters, groupPosts, isGroupBy } = this.props;
    const {shouldDowloadFile, preparingData} = this.state;
    const category = filters.category.value !== '' ? '-' + filters.category.value : '';
    const editor = filters.editor.value !== '' ? '-' + filters.editor.value : '';
    const editor_type = filters.editor_type.value !== '' ? '-' + filters.editor_type.value : '';
    const start_date = moment(filters.start_date.value).format("DD/MM");
    const end_date = moment(filters.end_date.value).format("DD/MM");
    let filename = `nhuan${editor_type}${category}${editor}-${start_date}-${end_date}`;
    let multiDataSet;
    if(groupPosts && isGroupBy){
      multiDataSet = [{
        columns: ["Phóng viên", "Số lượng bài viết", "Số lượng bài viết có Video", "Số lượng bài viết không Video", "Tổng view", "Tổng view Tốt", "Tổng view có Video", "Tổng view không Video", "Thời gian đọc", "Thời gian đọc (có Video)", "Thời gian đọc (không Video)"],
        data: groupPosts
      }];
      filename = `group-phongvien${editor_type}${category}${editor}-${start_date}-${end_date}`;
    } else {
      multiDataSet = [{
        columns: ["Tiêu đề", "Ngày xuất bản", "Chuyên mục", "Phóng viên", "Bút danh", "TimeOnPage", "View", "View Tốt", "Video", "Điểm"],
        data: this.state.dataExcel
      }];
    }

    return (
      <>
      <Button 
      className="btn btn-primary btn-block" onClick={this.downloadData}
      disabled={preparingData}
      >
        <i className="fas fa-download mr-2"></i>
        {preparingData ? 'Loading...' : 'Export'}            
      </Button>
      { shouldDowloadFile &&
        <ExcelFile
        hideElement={true}
        filename={filename}>
        <ExcelSheet dataSet={multiDataSet} name="Nhuan" />
        </ExcelFile>
      }
      </>
    )
  }
}

export default connect(
  store => {
    return {
      profile: store.loginInfo.userInfo,
      router: store.router,
      posts: store.post.listRoyalties,
      totalPosts: store.post.totalRoyalties,
      totalMoneyEditor: store.post.totalMoneyEditor,
      totalMoney: store.post.totalMoney,
      totalMoneyPhoto: store.post.totalMoneyPhoto,
      config: store.config
    };
  },
  dispatch => {
    return {
      getListPost: value => {
        dispatch(postActions.getListRoyalties(value));
      }
    };
  }
)(Export);
